/* eslint no-multi-spaces: ["error", { exceptions: { "VariableDeclarator": true } }] */

export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_HEADERS = 'SET_HEADERS'

export const USER_SET_CURRENT = 'USER_SET_CURRENT'
export const USER_REMOVE_CURRENT = 'USER_REMOVE_CURRENT'
export const USER_ACCOUNTS = 'USER_ACCOUNTS'
export const USER_SUCCESS_STEP = 'USER_SUCCESS_STEP'
export const USER_SET_TEMP = 'USER_SET_TEMP'
export const USER_REMOVE_TEMP = 'USER_REMOVE_TEMP '

export const ACCOUNT_LIST = 'ACCOUNT_LIST'
export const ACCOUNT_LIST_REQUEST = 'ACCOUNT_LIST_REQUEST'
export const ACCOUNT_TOGGLE = 'ACCOUNT_TOGGLE'

export const LINK_LIST = 'LINK_LIST'
export const LINK_LIST_REQUEST = 'LINK_LIST_REQUEST'

export const INST_DETAIL = 'INST_DETAIL'
export const INST_LIST = 'INST_LIST'
export const CATEGORY_LIST = 'CATEGORY_LIST'
export const INST_LIST_REQUEST = 'INST_LIST_REQUEST'
export const DESIG_LIST = 'DESIG_LIST'

export const GROUP_LIST = 'GROUP_LIST'
export const GROUP_DETAIL = 'GROUP_DETAIL'
export const GROUP_LIST_REQUEST = 'GROUP_LIST_REQUEST'

export const HOME_LIST = 'HOME_LIST'
export const HOME_LIST_REQUEST = 'HOME_LIST_REQUEST'

export const TRANS_LIST = 'TRANS_LIST'
export const TRANS_LIST_REQUEST = 'TRANS_LIST_REQUEST'

export const ROUNDUP_LIST = 'ROUNDUP_LIST'
export const ROUNDUP_LIST_REQUEST = 'ROUNDUP_LIST_REQUEST'

export const NOTIF_LIST = 'NOTIF_LIST'
export const NOTIF_LIST_REQUEST = 'NOTIF_LIST_REQUEST'

// events

export const EVENTS_LIST_SEND = 'EVENTS_LIST_SEND'
export const EVENTS_LIST_SET = 'EVENTS_LIST_SET'
export const SEND_SET = 'SEND_SET'
export const QUERYID_SET = 'QUERYID_SET'
export const EVENTS_LIST_RESET = 'EVENTS_LIST_RESET'
